import auth from './auth.module'
import item from './item.module'

const modules = {
  auth,
  item
}

export default modules
